import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Row, Col, Form, Button, Alert } from "react-bootstrap";
import { signUp, resetSignUp } from "../../actions/auth-action";
import { Redirect, useHistory } from "react-router-dom";
import "./TokoSignUp.scss";
import { TokoRefCode } from "../../Const";

const TokoSignUp = (props) => {
  const { signUp, resetSignUp } = props;

  const signUpError = useSelector((state) => state.auth.signUpError);
  const signUpRedirect = useSelector((state) => state.auth.signUpRedirect);
  const signUpStart = useSelector((state) => state.auth.signUpStart);
  const signUpSuccess = useSelector((state) => state.auth.signUpSuccess);

  const history = useHistory();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    resetSignUp();
    return () => {
      resetSignUp();
    };
  }, [resetSignUp]);

  const clickSignUp = (e) => {
    e.preventDefault();
    signUp({
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      password_confirmation: confirmPass,
      referral_code: TokoRefCode,
      from: "web",
    });
  };
  if (signUpRedirect) {
    return <Redirect to="/verify-otp" />;
  }
  return (
    <div className="toko-signup">
      <Row>
        <Col className="left-panel">
          <div>
            <img
              src="/images/ch2.png"
              className="crytohero-image"
              width="150"
            />
            <img src="/images/toko.png" className="toko-image" width="180" />
          </div>
          <div>
            <img src="/images/login.png" className="feature-image" />
          </div>
        </Col>
        <Col className="right-panel">
          <div className="signup-panel">
            <h6 className="mt-2 header-text">Create New Account</h6>
            <Form style={{ marginTop: 30 }}>
              <div style={{ fontSize: 12 }}>
                Create an account now, and start using ForexHero bot with your
                Tokocrypto API. Please use your Tokocrypto email to sign up.
              </div>
              <Form.Group className="toko-form">
                <Form.Control
                  as="input"
                  placeholder="First name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="toko-form">
                <Form.Control
                  as="input"
                  placeholder="Last name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="toko-form">
                <Form.Control
                  as="input"
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="toko-form">
                <Form.Control
                  as="input"
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="toko-form">
                <Form.Control
                  as="input"
                  placeholder="Repeat password"
                  type="password"
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Check
                label={
                  <p>
                    I agree to ForexHero{" "}
                    <a
                      href="https://ForexHero.ai/terms-of-service/"
                      target="_blank"
                    >
                      Terms of service
                    </a>
                  </p>
                }
                className="terms"
                value={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
              <div className="my-3">
                <Button
                  type="submit"
                  onClick={clickSignUp}
                  className={"toko-button"}
                  disabled={!checked}
                >
                  {signUpStart ? "SUBMITTING..." : "SIGN UP"}
                </Button>
                <Button
                  type="submit"
                  onClick={() => history.push("/tokocrypto")}
                  className={"toko-button-login"}
                >
                  LOGIN
                </Button>
              </div>

              <Alert
                show={signUpError != null || signUpSuccess}
                variant={signUpSuccess ? "success" : "danger"}
                className="mt-2"
              >
                {signUpError || "Account has been created!"}
              </Alert>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default connect(null, { signUp, resetSignUp })(TokoSignUp);
